import React, {useContext} from 'react';
import Badge from "../../../../../components/Badge";
import {FormattedMessage} from "react-intl";
import {ContextualMenu} from "../../../../../components/WMS/Mobile/ContextualMenu";
import {Grid} from "@mui/material";
import {red500} from "../../../../../assets/jss/main";
import {SortingContext} from "../SortingContext";

import {ReactComponent as DotsIcon} from 'assets/img/wms/more.svg';
import {ReactComponent as LogoutIcon} from 'assets/img/logout.svg';

function DrawerHeaderMenu({itemCount = null, additionalMenu = null}) {
    const {isScanFinish, inSorting, handleStopSorting} = useContext(SortingContext)

    return (
        <>
            {isScanFinish &&
                <Badge
                    label={<FormattedMessage id={"wms.sorting.scan.scanIsFinished.label"}/>}
                    color={"online"}
                    rounded
                    isBold={false}
                    size={"large"}
                /> ||
                <Badge
                    rounded
                    isBold={false}
                    size={"large"}
                >
                    {itemCount && inSorting && (
                        <>
                            {itemCount} <FormattedMessage id={"wms.sorting.toScanArticle"}/>
                        </>
                    )}
                    {itemCount && !inSorting && (
                        <>
                            {itemCount} <FormattedMessage id={"wms.sorting.article"}/>
                        </>
                    )}
                </Badge>
            }
            {inSorting && (
                <ContextualMenu icon={DotsIcon}>
                    <Grid
                        container flexDirection={'row'}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        onClick={handleStopSorting}
                    >
                        <Grid item style={{color: red500}}>
                            <FormattedMessage id={"wms.sorting.inSorting.finishSorting.label"}/>
                        </Grid>
                        <Grid item style={{maxWidth: '20px', maxHeight: '20px'}}>
                            <LogoutIcon/>
                        </Grid>
                    </Grid>
                    {additionalMenu && (
                        <span>
                            {additionalMenu}
                        </span>
                    )}
                </ContextualMenu>
            )}
        </>
    );
}

export default DrawerHeaderMenu;